(function () {
(function($) {
    const behavior = "polyu_theme.sub-footer-highlight-links";
    Drupal.behaviors[behavior] = {
        attach: (context, settings)=>{}
    };
    $(function() {});
})(jQuery);

})();
//# sourceMappingURL=paragraph--sub-footer-highlight-links.js.map
